import React, { useState, useEffect, useContext } from "react";
import ThumbnailOverlay from "./ThumbnailOverlay";

import {TranslationsContext} from "@proxy/_contexts";

export default function OverlayMiddleThumbnail({
  media,
  videoDuration,
  updateFormField,
  formData,
  setHasThumbnail
}) {
  const translations = useContext(TranslationsContext);

  const [customThumbnail, setCustomThumbnail] = useState("");
  const [tainted, setTainted] = useState(false);
  const [thumbnailMessage, setThumbnailMessage] = useState(translations.video_recorder_thumbnail_message)

  useEffect(() => {
    if (tainted) {
      setThumbnailMessage(translations.video_recorder_tainted_thumbnail_message);
    }
  }, [tainted]);

  return (
    <div className={"gc__thumbnail_select_container"}>
      <div className={"gc__thumbnail_message"}>
        <ThumbnailOverlay
          media={media}
          videoDuration={videoDuration}
          customThumbnail={customThumbnail}
          updateFormField={updateFormField}
          formData={formData}
          tainted={tainted}
          setTainted={setTainted}
          setHasThumbnail={setHasThumbnail}
        />
        <div>
          <h2 className={"gc__thumbnail_header"}>{translations.video_recorder_thumbnail_heading}</h2>
          <p className="gc__select_thumbnail_message">{`${thumbnailMessage} `}
            <label htmlFor="gc__thumbnail_upload" className="gc__thumbnail_upload_label">
              { translations.video_recorder_thumbnail_button }
            </label>
            <input
              id="gc__thumbnail_upload"
              type="file"
              onChange={(e) => {
                const input = document.getElementById("gc__thumbnail_upload");
                const fileReader = new FileReader();
                fileReader.readAsDataURL(input.files[0]);
                fileReader.onloadend = function(event) {
                  setCustomThumbnail(event.target.result);
                  setHasThumbnail(true);
                }
              }}
            />
          </p>
        </div>
      </div>
    </div>
  );
}
